<div class="guide">
  <header class="guide-header">
    <div class="lang-switch" role="group" aria-label="Language">
      <button type="button" [class.active]="lang === 'de'" (click)="setLang('de')">DE</button>
      <button type="button" [class.active]="lang === 'en'" (click)="setLang('en')">EN</button>
    </div>
    <h1>{{ pageTitle }}</h1>
    <p class="subtitle">{{ plain('subtitle') }}</p>
  </header>

  <section id="intro">
    <p>{{ plain('introP1') }}</p>
    <p [innerHTML]="t('introP2')"></p>
    <p [innerHTML]="t('introP3')"></p>
  </section>

  <section id="roles">
    <h2 [innerHTML]="t('s1Heading')"></h2>
    <p [innerHTML]="t('s1P1')"></p>
    <p>{{ plain('s1ListIntro') }}</p>
    <div class="verb-row">
      <div class="verb-chip verb-read">{{ lang === 'de' ? 'Lesen' : 'Read' }}</div>
      <div class="verb-chip verb-write">{{ lang === 'de' ? 'Schreiben' : 'Write' }}</div>
      <div class="verb-chip verb-delete">{{ lang === 'de' ? 'Löschen' : 'Delete' }}</div>
    </div>
    <ul class="behavior-list">
      <li [innerHTML]="t('s1ListRead')"></li>
      <li [innerHTML]="t('s1ListWrite')"></li>
      <li [innerHTML]="t('s1ListDelete')"></li>
    </ul>
    <p [innerHTML]="t('s1P2')"></p>
    <div class="callout callout-info">
      <strong [innerHTML]="t('s1CalloutTitle')"></strong>
      <span [innerHTML]="t('s1CalloutBody')"></span>
    </div>
  </section>

  <section id="node-permissions">
    <h2 [innerHTML]="t('s2Heading')"></h2>
    <p [innerHTML]="t('s2P1')"></p>
    <div class="callout callout-warning">
      <strong [innerHTML]="t('s2CalloutTitle')"></strong>
      <span [innerHTML]="t('s2CalloutBody')"></span>
    </div>
    <p [innerHTML]="t('s2P2')"></p>
    <p [innerHTML]="t('s2P3')"></p>
  </section>

  <section id="references">
    <h2 [innerHTML]="t('s3Heading')"></h2>
    <p [innerHTML]="t('s3P1')"></p>
    <p [innerHTML]="t('s3P2')"></p>
    <p [innerHTML]="t('s3P3')"></p>

    <figure class="diagram">
      <img [src]="img('reference-node')" [alt]="plain('diagram1Alt')" />
    </figure>

    <p [innerHTML]="t('s3P4')"></p>
  </section>

  <section id="reference-storage">
    <h2 [innerHTML]="t('s4Heading')"></h2>
    <p class="quote" [innerHTML]="t('s4Quote')"></p>
    <p [innerHTML]="t('s4P1')"></p>
    <p [innerHTML]="t('s4P2')"></p>

    <figure class="diagram">
      <img [src]="img('permission-storage')" [alt]="plain('diagram2Alt')" />
    </figure>

    <p [innerHTML]="t('s4P3')"></p>
    <div class="callout callout-warning" [innerHTML]="t('s4P4')"></div>
  </section>

  <section id="recursive">
    <h2 [innerHTML]="t('s5Heading')"></h2>
    <p [innerHTML]="t('s5Intro')"></p>
    <ul class="behavior-list">
      <li [innerHTML]="t('s5P1')"></li>
      <li [innerHTML]="t('s5P2')"></li>
    </ul>

    <figure class="diagram">
      <img [src]="img('bulk-action')" [alt]="plain('diagram3Alt')" />
    </figure>

    <div class="callout callout-warning" [innerHTML]="t('s5P3')"></div>
  </section>

  <section id="new-role">
    <h2 [innerHTML]="t('s6Heading')"></h2>
    <ol class="steps">
      <li [innerHTML]="t('s6Li1')"></li>
      <li [innerHTML]="t('s6Li2')"></li>
      <li [innerHTML]="t('s6Li3')"></li>
      <li [innerHTML]="t('s6Li4')"></li>
      <li [innerHTML]="t('s6Li5')"></li>
      <li [innerHTML]="t('s6Li6')"></li>
    </ol>
  </section>

  <section id="mistakes">
    <h2 [innerHTML]="t('s7Heading')"></h2>
    <div class="callout callout-danger">
      <strong [innerHTML]="t('s7Q1')"></strong><br />
      {{ plain('s7A1') }}
    </div>
    <div class="callout callout-danger">
      <strong [innerHTML]="t('s7Q2')"></strong><br />
      {{ plain('s7A2') }}
    </div>
    <div class="callout callout-danger">
      <strong [innerHTML]="t('s7Q3')"></strong><br />
      <span [innerHTML]="t('s7A3')"></span>
    </div>
    <div class="callout callout-danger">
      <strong [innerHTML]="t('s7Q4')"></strong><br />
      {{ plain('s7A4') }}
    </div>
    <div class="callout callout-danger">
      <strong [innerHTML]="t('s7Q5')"></strong><br />
      {{ plain('s7A5') }}
    </div>
  </section>
</div>
